export default class Sanitizer {
  private value?: string
  private defaultValue?: string

  constructor(value: string | undefined, defaultValue?: string) {
    this.value = value
    this.defaultValue = defaultValue
  }

  // Sanitizers

  public length({ max }: { max: number }) {
    this.value = this.value && this.value.slice(0, max)
    return this
  }

  public replace(regex: RegExp | string, replaceValue?: string) {
    this.value = this.value && this.value.replace(regex, replaceValue || '')
    return this
  }

  // Conversion

  public asString() {
    return this.value || this.defaultValue
  }

  public asValidString<A extends string>(validValues: A[]): A | undefined {
    if (this.value && validValues.includes(this.value as A)) {
      return this.value as A
    } else {
      return this.defaultValue as A
    }
  }

  public asInt() {
    return parseInt(this.value || '', 10)
  }
}
